<template>
  <div class="loginPopover" v-show="isShow" ref="loginPopover">
    <div class="loginItem" @click="clickServiceAgreement">
      <div class="loginItemContent">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/serviceAgreementIcon.png"
          alt=""
        />
        <div class="text">服务协议</div>
      </div>
    </div>
    <div class="loginItem" @click="clickLogout">
      <div class="loginItemContent">
        <div class="icon logout-icon"></div>
        <div class="text">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isShow", "event"],
  methods: {
    // 点击服务协议
    clickServiceAgreement: function () {
      this.$emit("clickServiceAgreement");
    },
    // 点击退出登录
    clickLogout: function () {
      this.$emit("clickLogout");
    },
  },
  watch: {
    event: function (newVal) {
      if (newVal) {
        // 等待渲染管线 处理完v-show
        this.$nextTick(() => {
          // 判断是否存在currentTarget
          if (this.event.currentTarget) {
            const triggerEl = this.event.currentTarget;
            const triggerRect = triggerEl.getBoundingClientRect();

            const popoverEl = this.$refs["loginPopover"];
            const popoverRect =
              this.$refs["loginPopover"].getBoundingClientRect();
            const spacing = 8;

            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            // 默认位置（右侧对齐，向下展开）
            let top = triggerRect.bottom + spacing;
            let left = triggerRect.right - popoverRect.width;

            // 确保不超出右侧边界
            if (left + popoverRect.width > viewportWidth - spacing) {
              console.log("确保不超出右侧边界");
              left = viewportWidth - popoverRect.width - spacing;
            }

            // 确保不超出左侧边界
            if (left < spacing) {
              console.log("确保不超出左侧边界");
              left = spacing;
            }

            // 如果底部空间不足，则向上展开
            if (top + popoverRect.height > viewportHeight - spacing) {
              console.log("如果底部空间不足，则向上展开");
              top = triggerRect.top - popoverRect.height - spacing;
            }

            // 如果顶部也没有足够空间，则尽量显示在视口内
            if (top < spacing) {
              console.log("如果顶部也没有足够空间，则尽量显示在视口内");
              top = spacing;
            }

            // 设置样式：fixed 定位
            popoverEl.style.top = `${top}px`;
            popoverEl.style.left = `${left}px`;
          } else {
            // 使用点击坐标来定位弹窗
            console.log("iOS设备：使用clientX/Y定位弹窗");

            const popoverEl = this.$refs["loginPopover"];
            const popoverRect = popoverEl.getBoundingClientRect();
            const spacing = 8;

            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            // 检查事件对象是否包含客户端坐标
            if (
              this.event.clientX !== undefined &&
              this.event.clientY !== undefined
            ) {
              // 默认位置（鼠标点击位置下方）
              let top = this.event.clientY + spacing;
              let left = this.event.clientX - popoverRect.width / 2; // 水平居中于点击位置

              // 确保不超出右侧边界
              if (left + popoverRect.width > viewportWidth - spacing) {
                console.log("确保不超出右侧边界");
                left = viewportWidth - popoverRect.width - spacing;
              }

              // 确保不超出左侧边界
              if (left < spacing) {
                console.log("确保不超出左侧边界");
                left = spacing;
              }

              // 如果底部空间不足，则向上展开
              if (top + popoverRect.height > viewportHeight - spacing) {
                console.log("如果底部空间不足，则向上展开");
                top = this.event.clientY - popoverRect.height - spacing;
              }

              // 如果顶部也没有足够空间，则尽量显示在视口内
              if (top < spacing) {
                console.log("如果顶部也没有足够空间，则尽量显示在视口内");
                top = spacing;
              }

              // 设置样式：fixed 定位
              popoverEl.style.top = `${top}px`;
              popoverEl.style.left = `${left}px`;
            } else {
              // 如果连clientX/Y都没有，使用屏幕中间位置
              console.log("无法获取点击坐标，使用屏幕中间位置");

              let top = viewportHeight / 3; // 屏幕上方1/3处
              let left = (viewportWidth - popoverRect.width) / 2; // 水平居中

              popoverEl.style.top = `${top}px`;
              popoverEl.style.left = `${left}px`;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./loginPopover.scss";
</style>
